// /opt/isp_erp/frontend/src/components/tickets/MovimientoEquipos.jsx
import React from 'react';
import { Box, Chip, Stack, Typography } from '@mui/material';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';

const normalizar = (lista) => (Array.isArray(lista) ? lista : [])
  .map((e) => (typeof e === 'string' ? { sn: e } : e))
  .filter((e) => e && e.sn);

const sinRepetir = (lista) => {
  const vistos = new Set();
  return lista.filter((e) => (vistos.has(e.sn) ? false : vistos.add(e.sn)));
};

const ACCIONES = { CAMBIO: 'Cambio de equipo', RETIRO: 'Retiro de equipo', INSTALACION_ADICIONAL: 'Instalación de un equipo adicional', VARIOS: 'Varios movimientos de equipos' };

/** Movimiento de equipos de un ticket ya resuelto o cerrado (retirados e instalados). */
const MovimientoEquipos = ({ ticket }) => {
  const mu = ticket && ticket.materials_used;
  if (!mu || typeof mu !== 'object') return null;
  if (!['resuelto', 'cerrado'].includes(String(ticket.status || '').toLowerCase())) return null;

  const retirados = sinRepetir([...normalizar(mu.equipos_retirados_incidente), ...normalizar(mu.equipos_viejos), ...normalizar(mu.equipos_retirados)]);
  const instalados = sinRepetir([...normalizar(mu.equipos_instalados_incidente), ...normalizar(mu.equipos_nuevos), ...normalizar(mu.equipos_instalados)]);
  if (retirados.length === 0 && instalados.length === 0) return null;

  const chip = (e, color) => (
    <Chip key={e.sn} size="small" color={color} variant="outlined" label={`${e.sn}${e.modelo ? ` — ${e.modelo}` : ''}`} />
  );

  return (
    <Box sx={{ my: 1.5, p: 1.5, border: '1px solid', borderColor: 'divider', borderRadius: 1 }}>
      <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 0.5 }}>
        <SwapHorizIcon color="primary" fontSize="small" />
        <Typography variant="subtitle2">Movimiento de equipos</Typography>
        {mu.accion_equipos && <Chip size="small" label={ACCIONES[mu.accion_equipos] || mu.accion_equipos} />}
      </Stack>
      {retirados.length > 0 && (
        <Box sx={{ mb: 0.75 }}>
          <Typography variant="caption" color="text.secondary">Retirados</Typography>
          <Stack direction="row" flexWrap="wrap" gap={0.75} sx={{ mt: 0.25 }}>{retirados.map((e) => chip(e, 'warning'))}</Stack>
        </Box>
      )}
      {instalados.length > 0 && (
        <Box>
          <Typography variant="caption" color="text.secondary">Instalados</Typography>
          <Stack direction="row" flexWrap="wrap" gap={0.75} sx={{ mt: 0.25 }}>{instalados.map((e) => chip(e, 'success'))}</Stack>
        </Box>
      )}
      {mu.comentario_equipos && (
        <Typography variant="body2" sx={{ mt: 0.75 }}>Comentario: {mu.comentario_equipos}</Typography>
      )}
    </Box>
  );
};

export default MovimientoEquipos;
